import { z } from 'zod';
import { makeFieldSchemaFromZod } from '@backstage/plugin-scaffolder';

// @ts-ignore
const BotIdPickerFieldSchema = makeFieldSchemaFromZod(z.string());

export const BotIdPickerSchema = BotIdPickerFieldSchema.schema;

export type BotIdPickerProps = typeof BotIdPickerFieldSchema.type;
